import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { FormControl, IconButton, InputAdornment, InputBase, Paper } from "@mui/material";
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import icon_password from "../Assets/Icons/IconPassword.svg";
import DoriLogo from '../Assets/Icons/DoriLogo.png';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { useDispatch, useSelector } from "react-redux";
import { getLoginLoader, login } from "../APILayer/CommonAPIs/ApiLogin";
import store from "../storage";
import {
  initialAnalyticSummaryPageData,
  setAnalyticSummaryPageData,
  setApplicationConfig,
  setCameraData,
  setCameraSelected,
  setDashboardConfig,
  setEnabledRoutes,
  setIsLoggedIn,
  setLocationsData,
  setLocationSelected,
  setSearchEndDate,
  setSearchStartDate,
  setWholeData,
  setAutoRefreshTime
} from "../Redux/DashboardVariables";
import Config from "./Config";
import { ScaleLoader } from "react-spinners";
import DismissAction from "CommonComponents/DismissAction";
import { useSnackbar } from "notistack";
import { showSnackbar } from "Redux/ShowSnackbar";
import { setCompanyDetails } from "APILayer/CommonAPIs/ApiCodGetCompanyDetails";

const Login = () => {
  const loginLoading = useSelector(getLoginLoader);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState({
    password: "",
    showPassword: false,
  });

  const clearAllData = () => {
    store.clear();
    dispatch(setIsLoggedIn(false));
    dispatch(setCompanyDetails([]));
    dispatch(setDashboardConfig(''));
    dispatch(setApplicationConfig(''));
    dispatch(setEnabledRoutes([]));
    dispatch(setWholeData([]));
    dispatch(setLocationSelected(''));
    dispatch(setCameraSelected(''));
    dispatch(setCameraData([]));
    dispatch(setLocationsData([]));
    dispatch(setAnalyticSummaryPageData(initialAnalyticSummaryPageData));
    dispatch(setAutoRefreshTime(0));
  }

  useEffect(() => {
    if (window.location.href.includes('login')) {
      clearAllData();
    }
  }, [])

  const handleChangePassword = (prop) => (event) => {
    setPassword({ ...password, [prop]: event.target.value.trim() });
  };

  const handleClickShowPassword = () => {
    setPassword({
      ...password,
      showPassword: !password.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const onLoginSuccess = (data) => {
    store.set('authToken', data.user.authToken);
    store.set('user', data.user);
    store.set("buildVersion", data.user.buildVersion);
    store.set("locationId", data.user.locationId);
    store.set("isLoggedIn", true);
    dispatch(setIsLoggedIn(true));
    dispatch(showSnackbar({
      message: "Login Successful.",
      severity: 'success',
    }));
  };

  const onLoginFailure = () => {
    dispatch(showSnackbar({
      message: "Login Failed.",
      severity: 'error',
    }));
  }

  const handleSubmit = (e) => {
    dispatch(setSearchStartDate(new Date(new Date().getTime() - 3600 * 1000)));
    dispatch(setSearchEndDate(new Date(new Date().setHours(23, 59, 59, 999))))
    dispatch(login({
      email,
      password: password.password
    },
      onLoginSuccess,
      onLoginFailure
    ));
    e.preventDefault();
  }

  // console.log('companies in log in page: ', companydetails);

  return (
    <>
      {
        process.env.REACT_APP_DORI_APP_SERVER
          ? null
          : <Config />
      }

      <div style={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgb(243, 243, 243)',
        boxSizing: 'border-box'
      }}>
        {/* {loginInProgress && <DoriLoader label="Logging In..." />} */}
        <div style={{
          height: '100vh',
          width: '50vw',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '10px',
          boxSizing: 'border-box'
        }}>
          <Paper
            style={{
              width: '100%',
              padding: '10px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              boxSizing: 'border-box'
            }}>
            <div style={{
              width: '100%',
              padding: '10px',
              backgroundColor: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '10vh',
              boxSizing: 'border-box'
            }}>
              <img
                src={DoriLogo}
                alt='Logo'
                height='70%'
              />
            </div>
            <Typography style={{ fontSize: '28px' }}>
              Welcome to Dori AI Vision
            </Typography>
            <br />
            <Typography style={{ fontSize: '14px' }}>
              Login to your account
            </Typography>
            <br />

            <FormControl
              onSubmit={handleSubmit}
              style={{ width: '75%' }}
            >
              <Paper
                component="form"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  marginBottom: "25px",
                  border: "1px solid silver",
                  boxShadow: "none",
                }}
              >
                <IconButton sx={{ p: "10px" }} aria-label="menu" disabled>
                  <EmailOutlinedIcon sx={{ color: "darkgray" }} />
                </IconButton>
                <TextField
                  fullWidth
                  sx={{ ml: 1, flex: 1, fontSize: "14px" }}
                  variant="standard"
                  InputProps={{
                    disableUnderline: true,
                  }}
                  placeholder="Email ID"
                  id="Email"
                  className="logintextfield"
                  value={email}
                  onChange={(e) => setEmail(e.target.value.trim())}
                  inputProps={{ "aria-label": "Email ID" }}
                />
              </Paper>

              <Paper
                component="form"
                sx={{
                  display: "flex",
                  width: '100%',
                  alignItems: "center",
                  border: "1px solid silver",
                  boxShadow: "none",
                }}
              >
                <IconButton sx={{ p: "10px" }} aria-label="menu" disabled>
                  <img src={icon_password} />
                </IconButton>
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  type={password.showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password.password}
                  onChange={handleChangePassword("password")}
                  id="password"
                  inputProps={{ "aria-label": "Email ID" }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                        sx={{
                          marginRight: "0px",
                          fontSize: "14px",
                        }}
                      >
                        {password.showPassword ? (
                          <VisibilityOffOutlinedIcon />
                        ) : (
                          <VisibilityOutlinedIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </Paper>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: '20px',
                marginBottom: '20px'
              }}>
                {loginLoading
                  ?
                  <Button
                    style={{
                      width: '35%',
                      backgroundColor: '#17b696',
                      boxShadow: 'none',
                      color: '#FFF',
                      fontSize: '14px',
                      fontStyle: 'normal',
                      fontWeight: '700',
                      lineHeight: '20px',
                      padding: '8px 24px',
                      textTransform: 'none'
                    }}
                    variant="contained"
                    type="submit"
                  >
                    <ScaleLoader
                      height={16}
                      width={4}
                      radius={4}
                      margin={2}
                      // style={{ marginTop: "2px" }}
                      color={"white"}
                    />
                  </Button>
                  :
                  <Button
                    style={{
                      width: '35%',
                      backgroundColor: '#17b696',
                      boxShadow: 'none',
                      color: '#FFF',
                      fontSize: '14px',
                      fontStyle: 'normal',
                      fontWeight: '700',
                      lineHeight: '20px',
                      padding: '8px 24px',
                      textTransform: 'none'
                    }}
                    onClick={handleSubmit}
                    variant="contained"
                    type="submit"
                  >
                    Sign In
                  </Button>
                }

                <div style={{ color: 'gray' }}>
                  FORGOT PASSWORD?
                </div>
              </div>
              <div style={{
                width: '100%',
                textAlign: 'center',
                color: '#8B8B8B',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: '500',
                lineHeight: '20px'
              }}>
                Dashboard Version: {process.env.REACT_APP_BUILD_VERSION}
              </div>

            </FormControl>
          </Paper>
        </div>
      </div>
    </>
  );
}

export default Login;